import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ISessionResponse } from '@shared/interfaces/session.interface';
import { Observable } from 'rxjs';
import { HttpFilterModel } from '@shared/models/http-filter.model';
import { createHttpParams } from '../utils/http-utils';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  http = inject(HttpClient);

  getSessionsForActiveCounters(
    page: number,
    size: number,
    computerName?: string,
    defPort?: string,
  ): Observable<ISessionResponse> {
    const params = createHttpParams({
      page,
      size,
      sessionStatus: 'ACTIVE',
      machineType: 'COUNTER',
      computerName,
      defPort,
      airlineCode: 'PC',
    });

    return this.http.get<ISessionResponse>('sessions', { params });
  }

  getSessionsForArchivedCounters(
    page: number,
    size: number,
    computerName?: string,
    loginTimeFrom?: string,
    logoutTimeTo?: string,
    applicationType?: string,
    userName?: string,
    defPort?: string,
  ): Observable<ISessionResponse> {
    const params = createHttpParams({
      page,
      size,
      sessionStatus: 'HISTORY',
      machineType: 'COUNTER',
      computerName,
      loginTimeFrom,
      logoutTimeTo,
      applicationType,
      userName,
      defPort,
      airlineCode: 'PC',
    });

    return this.http.get<ISessionResponse>('sessions', { params });
  }

  getSessionForKiosk(page: number, size: number, kioskName?: string): Observable<ISessionResponse> {
    const params = createHttpParams({
      page,
      size,
      machineType: 'KIOSK',
      kioskName,
      airlineCode: 'PC',
    });

    return this.http.get<ISessionResponse>('sessions', { params });
  }
}
